var scope_0 = require('/Users/wil5243/fullstackzach/git-talk/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/296eca817a8e858e8bf791303e2a17c8.js').default;export default
        Object.assign({}, scope_0 )
    